// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1885) return "static/chunks/1885-cc2caa9854317c4e.js";
	if (chunkId === 2043) return "static/chunks/2043-003eadca82f29722.js";
	if (chunkId === 7202) return "static/chunks/7202-2e95fd53fec956f2.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1227":"50305303873bf504","1652":"ac82bfe38753e438","5964":"b9f5608677c2f33e","7245":"40e3bda249c2622b"}[chunkId] + ".js";
};